import React, { useEffect, useState } from 'react'
import {
  Button,
  Dialog,
  CircularProgress,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  TextField,
} from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../reducers'
import { Clear as ClearIcon } from '@mui/icons-material'
import { useStyles } from './SlidesStyles'
import { clearSessionToken, userSessionToken } from '../../actions'

export default function ReleaseAuthPrompt({
  isReleaseAuthPromptOpen,
  handleReleaseAuthPromptClose,
  isTokenActive,
  setPdfUrl,
}) {
  const classes = useStyles()
  const dispatch = useDispatch()
  const { user } = useSelector((state: RootState) => state.userLogin)
  const [isLoading, setLoading] = useState(false)
  const pdfUrlData = useSelector((state: RootState) => state.getPDFBytes)
  const [pdfFlag, setPdfFlag] = useState(true)
  const [password, setPassword] = useState('')
  const [isShowError, setShowError] = useState(false)
  const { error, errorMessage } = useSelector((state: RootState) => state.getsessionStatus)

  useEffect(() => {
    if (pdfFlag && pdfUrlData && pdfUrlData.payload && pdfUrlData.payload.length > 0) {
      setPdfUrl(pdfUrlData.payload + '#zoom=100&')
      setPdfFlag(false)
    }
  }, [pdfUrlData, pdfFlag])

  useEffect(() => {
    if (error && errorMessage !== 'success') {
      setLoading(false)
      setShowError(true)
    } else if (errorMessage === 'success') {
      setLoading(false)
      setShowError(false)
      setPassword('')
      handleReleaseAuthPromptClose(true)
    }
  }, [error, errorMessage, isLoading])

  const onChangePasswordPress = async (e) => {
    if (e?.charCode === 13) {
      setLoading(true)
      await dispatch(userSessionToken({ userId: user, password: password }))
    }
  }

  const releaseHandleReport = async () => {
    if (password === '') return
    setLoading(true)
    await dispatch(userSessionToken({ userId: user, password: password }))
  }

  const handleClose = () => {
    setShowError(false)
    dispatch(clearSessionToken())
    handleReleaseAuthPromptClose(false)
  }

  return (
    <>
      {isTokenActive === false && (
        <Dialog fullWidth maxWidth="sm" open={isReleaseAuthPromptOpen} onClose={handleClose}>
          <DialogTitle className={classes.dialogTitle}>Enter password to release report</DialogTitle>
          <Divider />
          <DialogContent>
            <DialogContentText className={classes.dialogContent}>
              Enter your password to release the report. This confirmation is valid for next 2 hours.
            </DialogContentText>
            <TextField
              autoFocus
              margin="dense"
              id="name"
              label="Password"
              onChange={(e) => setPassword(e.target.value)}
              value={password}
              type="password"
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              style={{ width: '250px', marginTop: '20px' }}
              onKeyPress={(e) => onChangePasswordPress(e)}
            />
            {isLoading && (
              <CircularProgress
                style={{ color: '#0A688D', marginTop: '30px', marginLeft: '15px', height: '30px', width: '30px' }}
              />
            )}
            {error && errorMessage !== '' && isShowError && (
              <p className={classes.error}>Incorrect password, please enter correct password to continue</p>
            )}
          </DialogContent>
          <DialogActions className={classes.buttonActions}>
            <Button onClick={releaseHandleReport} className={`${classes.buttonMargin} ${classes.saveButton}`}>
              Submit
            </Button>
            <Button
              className={`${classes.buttonMargin}`}
              variant="outlined"
              endIcon={<ClearIcon />}
              onClick={handleClose}
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  )
}
